document.addEventListener("DOMContentLoaded",()=>{

const sticky=document.querySelector(".kb-sticky-atc");
const original=document.querySelector("product-form");

if(!sticky||!original)return;

const observer=new IntersectionObserver((entries)=>{

entries.forEach(entry=>{

if(entry.isIntersecting){
sticky.classList.remove("show");
}else{
sticky.classList.add("show");
}

});

});

observer.observe(original);

sticky.querySelector("button").addEventListener("click",()=>{

const btn=document.querySelector('product-form button[type="submit"]');

if(btn){
btn.click();
}

});

});